import { useMemo } from 'react';
import { Transaction, TransactionShort, getCurrencyIcon, makeFloat } from 'react-easyrocket';
import { TableCell } from 'src/components/Table/components/TableCell';
import { checkIfElementPresentsInArray } from 'src/utils';
import { StatusCell } from './components/StatusCell';
import dayjs from 'dayjs';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export const TableRowTransaction = ({ data }: { data: Transaction | TransactionShort }) => {
  const { id, type, amount, dateComplete, dateCreate, currency, status, commission, stringId } =
    data;
  const { t } = useTranslation();

  const TRANSACTION_STATUS: { [key: string]: string } = {
    '0': `${t('transactionStatus.pending')}`,
    '1': `${t('transactionStatus.complete')}`,
    '2': `${t('transactionStatus.cancel')}`,
    '3': `${t('transactionStatus.failed')}`,
    '4': `${t('transactionStatus.refund')}`,
    '5': `${t('transactionStatus.pendingWager')}`,
    '6': `${t('transactionStatus.rejected')}`,
    '7': `${t('transactionStatus.notConfirmed')}`,
    '8': `${t('transactionStatus.processing')}`,
    '9': `${t('transactionStatus.aggregatorRejected')}`,
    '10': `${t('transactionStatus.rollback')}`,
    '11': `${t('transactionStatus.wagerZeroing')}`,
    '12': `${t('transactionStatus.notConfirmedBlockAmount')}`
  };

  const textYellow = useMemo(() => checkIfElementPresentsInArray([0, 7, 8, 12], status), [status]);
  const textRed = useMemo(
    () => checkIfElementPresentsInArray([2, 3, 4, 6, 9, 10], status),
    [status]
  );
  const textGreen = useMemo(() => checkIfElementPresentsInArray([1, 5, 11], status), [status]);

  const formatDate = (date: string | number) => {
    return typeof date === 'string'
      ? dayjs(date).format('DD-MM-YYYY')
      : dayjs(date * 1000).format('DD-MM-YYYY');
  };

  const date = dateComplete ? formatDate(dateComplete) : formatDate(dateCreate);

  return (
    <tr className="odd:bg-wthap_table_bg text-center">
      <TableCell
        item={id}
        className="!text-wthap_table_yellow_text font-bold pl-0"
        innerClassName="text-start pl-[5px]"
      />
      <TableCell item={makeFloat(amount)} innerClassName="text-start pl-[80px]" className="pl-0" />
      <TableCell
        item={`${makeFloat(commission)}${getCurrencyIcon(currency)}`}
        innerClassName="text-start pl-[80px]"
        className="pl-0"
      />
      <TableCell item={`${currency}`} innerClassName="text-start pl-[80px]" className="pl-0" />
      <StatusCell
        id={stringId}
        transactionId={id}
        status={status}
        type={type}
        item={
          <>
            <p className="text-end pr-[5px]">{date}</p>
            <p
              className={classNames(
                'font-bold text-end pr-[5px] whitespace-pre-line',
                textYellow && 'text-wthap_table_yellow_text',
                textGreen && 'text-wthap_table_green_text',
                textRed && 'text-wthap_table_red_text'
              )}>
              {t(TRANSACTION_STATUS[status])}
            </p>
          </>
        }
        className="pr-0"
      />
    </tr>
  );
};
